export default {
    'currencies-settings': 'التحكم بإخفاء العملات',
    'show-currency-symbol': 'إظهار رموز العملات',
    'Asking-about-the-date-of-the-bond-accounting-or-cash-before-it-was-created': 'السؤال عن تاريخ السند (المُحاسبي/النقدي) قبل إنشائه',
    'show-the-dialog-to-choose-the-date-instead-of-adopting-today-date': 'إظهار مربع الحوار لختيار التاريخ (بدلاً من اعتماد تاريخ اليوم)',
    'open-account-statement-in-new-window': 'فتح كشف الحساب في تبويبة جديدة',
    'opening-account-statement-in-new-window-from-accounting-journal': 'فتح كشف الحاسب لإحدى مدخلات اليومية المحاسبية في تبويبة جديدة',
}